import React from 'react';
import clsx from 'clsx';
import ButtonGroup from '@mui/material/ButtonGroup';
import {
  ClaimViews,
} from 'dtos/claimViews';
import Button from 'pages/Dashboard/components/Button';
import {
  ClaimTagByType,
} from 'pages/Dashboard/pages/Billing/Charges/columns/ClaimTag';

type Props = {
  value: ClaimViews;
  onChange: (value: ClaimViews) => void;
  className?: string;
};

type ClaimTypeOption = {
  value: ClaimViews;
  badgeProps?: {
    hasSecondary?: boolean;
    isSecondary?: boolean;
  };
};

const claimTypeOptions: ClaimTypeOption[] = [
  {
    value: ClaimViews.All,
  },
  {
    value: ClaimViews.Primary,
    badgeProps: { hasSecondary: true },
  },
  {
    value: ClaimViews.Secondary,
    badgeProps: { isSecondary: true },
  },
];

export default function ClaimTypeTabs({
  value,
  onChange,
  className,
}: Props) {
  return (
    <div className={clsx('flex items-center min-w-0', className)}>
      <ButtonGroup
        className="!h-[34px]"
        variant="outlined"
        color="inherit"
        aria-label="Claim type view"
      >
        {claimTypeOptions.map(({ value: _value, badgeProps }) => {
          const isActive = value === _value;

          return (
            <Button
              key={_value}
              className={clsx(
                'flex items-center gap-1.5 !h-full !min-w-0 !rounded-none first:!rounded-l-md last:!rounded-r-md !px-3 !cursor-pointer',
                { '!bg-blue-50 !text-neutral-700': isActive },
                { '!text-neutral-700': !isActive },
              )}
              type="button"
              variant="outlined"
              aria-pressed={isActive}
              onClick={() => {
                onChange(_value);
              }}
            >
              {badgeProps && <ClaimTagByType {...badgeProps} />}
              <span>{_value}</span>
            </Button>
          );
        })}
      </ButtonGroup>
    </div>
  );
}
